import wikiWindows from './modules/wiki-windows'
import buttonEvents from './modules/button-events'
import clockEvent from './modules/clock-event'

wikiWindows()
buttonEvents()
clockEvent()
